<script setup lang="ts">
import type { ComboboxItemEmits, ComboboxItemProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { ComboboxItem, useForwardPropsEmits } from 'reka-ui';
import { computed } from 'vue';

const props = withDefaults(
	defineProps<ComboboxItemProps & { class?: HTMLAttributes['class'] }>(),
	{
		as: 'div'
	}
);
const emits = defineEmits<ComboboxItemEmits>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<ComboboxItem
		v-bind="forwarded"
		:class="
			cn(
				'relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none data-disabled:pointer-events-none data-highlighted:bg-white-dark-1 data-highlighted:text-primary data-disabled:opacity-50',
				props.class
			)
		"
	>
		<slot />
	</ComboboxItem>
</template>
